function downloadPDF () {
  return fetch(offer.downloadPDFEndpoint)
    .then((response) => response.json())
    .then((data) => {
      let dummyLink = document.querySelector('#dummy-link')
      if (!dummyLink) {
        dummyLink = document.createElement('a')
        dummyLink.setAttribute('download', data.readableFileName)
        document.body.appendChild(dummyLink)
      }
      dummyLink.setAttribute('href', data.downloadUrl)
      dummyLink.click()
    })
}

const downloadButtons = document.querySelectorAll('.download-button')
downloadButtons.forEach(downloadButton => {
  downloadButton.addEventListener('click', () => {
    const label = downloadButton.querySelector('.label')
    const loader = downloadButton.querySelector('.loader')
    label.style.visibility = 'hidden'
    loader.style.display = 'inline'
    downloadPDF().then(() => {
      loader.style.display = 'none'
      label.style.visibility = 'visible'
    })
  })
})

